import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import './assets/common.css';

import { Button, Select, Option, Input, Form, FormItem, Dialog, checkbox,Carousel, CarouselItem, Message ,} from 'element-ui';
Vue.use(Button);
Vue.use(Select);
Vue.use(Option);
Vue.use(Input);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Dialog);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(checkbox)
Vue.prototype.$message = Message

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
